<template>
  <div class="approval-history">
    <div v-if="isLoading" class="text-center py-3">
      <b-spinner small variant="primary" />
    </div>
    <p v-else-if="!histories.length" class="text-center text-muted py-3 mb-0">
      {{ errorText || 'Chưa có lịch sử thay đổi' }}
    </p>
    <b-col v-else>
      <div v-for="(history, index) in histories" :key="index">
        <b-row>
          <b-col md="3">
            <label class="lable-sp">Hành động: </label>
          </b-col>
          <b-col md="9">
            <label>{{ history.actionName }}</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <label class="lable-sp">Chỉnh sửa bởi: </label>
          </b-col>
          <b-col md="9">
            <label>{{ history.employeeName }}</label>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col md="3">
            <label class="lable-sp">Chỉnh sửa lúc: </label>
          </b-col>
          <b-col md="9">
            <label>{{ history.createdAt }}</label>
          </b-col>
        </b-row>
        <b-table
          v-if="history.diffValues && history.diffValues.length"
          bordered
          hover
          :fields="historyDetailFields"
          :items="history.diffValues"
        >
        </b-table>
        <hr class="hr-text mb-4" data-content="" style="font-weight: 600" />
      </div>
    </b-col>
  </div>
</template>
<script>
import ApiService from '@/core/services/api.service';

export default {
  // `historyUrl`: dùng lại cho màn khác (vd loại khách hàng); bỏ trống = lịch sử phiếu duyệt chi.
  // `lazy`: không tải lúc tạo, màn cha gọi getHistory() khi người dùng mở bước Lịch sử
  props: {
    approvalId: [Number, String],
    historyUrl: String,
    lazy: { type: Boolean, default: false },
  },
  data() {
    return {
      historyDetailFields: [
        {
          key: 'keyName',
          label: 'Thông tin',
          thStyle: { textAlign: 'center', width: '20%' },
          tdClass: 'text-left',
        },
        {
          key: 'originalValue',
          label: 'Trước',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '40%',
          },
        },
        {
          key: 'newValue',
          label: 'Sau',
          sortable: false,
          thStyle: {
            textAlign: 'center',
            color: 'rgb(24, 28, 50)',
            width: '40%',
          },
        },
      ],
      histories: [],
      requestSeq: 0,
      isLoading: false,
      errorText: '',
    };
  },
  created() {
    if (!this.lazy) {
      this.getHistory();
    }
  },
  methods: {
    getHistory() {
      this.histories = [];
      this.errorText = '';
      this.isLoading = true;
      const url = this.historyUrl || `v2/approval-histories/by-approval/${this.approvalId}`;
      // Mở bước Lịch sử liên tiếp: chỉ nhận kết quả lần gọi mới nhất, bỏ kết quả cũ về muộn
      const requestSeq = ++this.requestSeq;
      ApiService.get(url)
        .then(({ data }) => {
          if (requestSeq !== this.requestSeq) {
            return;
          }
          if (data.status === 200) {
            this.histories = data.data || [];
          } else {
            this.errorText = 'Không tải được lịch sử. Vui lòng thử lại.';
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (requestSeq !== this.requestSeq) {
            return;
          }
          const status = error && error.response ? error.response.status : null;
          this.errorText =
            status === 403
              ? 'Bạn không có quyền xem lịch sử'
              : 'Không tải được lịch sử. Vui lòng thử lại.';
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.approval-history {
  .lable-sp {
    font-weight: 500;
  }
}
</style>
